/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchRequestModel } from '../../models/search-request-model';
import { TitleModelSearchResultModel } from '../../models/title-model-search-result-model';

export interface TitleSearchTitlePost$Params {
      body?: SearchRequestModel
}

export function titleSearchTitlePost(http: HttpClient, rootUrl: string, params?: TitleSearchTitlePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<TitleModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, titleSearchTitlePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<TitleModelSearchResultModel>;
    })
  );
}

titleSearchTitlePost.PATH = '/Title/SearchTitle';
